/**
 * React Router v7 Configuration
 *
 * Defines all application routes with lazy loading for code splitting
 */

import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load page components for code splitting
const HomePage = lazy(() => import('@/app/pages/HomePage').then((m) => ({ default: m.HomePage })));
const AboutPage = lazy(() => import('@/app/pages/AboutPage').then((m) => ({ default: m.AboutPage })));
const CatalogPage = lazy(() => import('@/features/catalog/components/CatalogPage').then((m) => ({ default: m.CatalogPage })));
const ProductPage = lazy(() => import('@/features/product/components/ProductPage').then((m) => ({ default: m.ProductPage })));
const CartPage = lazy(() => import('@/features/cart/components/CartPage').then((m) => ({ default: m.CartPage })));
const CheckoutPage = lazy(() => import('@/features/checkout/components/CheckoutPage').then((m) => ({ default: m.CheckoutPage })));
const LoginPage = lazy(() => import('@/features/account/components/LoginPage').then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() => import('@/features/account/components/RegisterPage').then((m) => ({ default: m.RegisterPage })));
const AccountPage = lazy(() => import('@/features/account/components/AccountPage').then((m) => ({ default: m.AccountPage })));
const SearchPage = lazy(() => import('@/features/search/components/SearchPage').then((m) => ({ default: m.SearchPage })));
const WishlistPage = lazy(() => import('@/features/wishlist/components/WishlistPage').then((m) => ({ default: m.WishlistPage })));
const ContactPage = lazy(() => import('@/features/contact/components/ContactPage').then((m) => ({ default: m.ContactPage })));
const NotFoundPage = lazy(() => import('@/app/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));
const ErrorPage = lazy(() => import('@/app/pages/ErrorPage').then((m) => ({ default: m.ErrorPage })));
const MainLayout = lazy(() => import('@/shared/layouts/MainLayout').then((m) => ({ default: m.MainLayout })));
const TestShopifyPage = lazy(() => import('@/pages/TestShopifyPage').then((m) => ({ default: m.TestShopifyPage })));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'catalog',
        element: <CatalogPage />,
      },
      {
        path: 'catalog/:category',
        element: <CatalogPage />,
      },
      {
        path: 'products/:handle',
        element: <ProductPage />,
      },
      {
        path: 'cart',
        element: <CartPage />,
      },
      {
        path: 'checkout',
        element: <CheckoutPage />,
      },
      {
        path: 'account/login',
        element: <LoginPage />,
      },
      {
        path: 'account/register',
        element: <RegisterPage />,
      },
      {
        path: 'account',
        element: <AccountPage />,
      },
      {
        path: 'account/orders',
        element: <AccountPage />,
      },
      {
        path: 'account/addresses',
        element: <AccountPage />,
      },
      {
        path: 'account/profile',
        element: <AccountPage />,
      },
      {
        path: 'search',
        element: <SearchPage />,
      },
      {
        path: 'wishlist',
        element: <WishlistPage />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
      {
        path: 'test-shopify',
        element: <TestShopifyPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
